import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

class Tab extends Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    indexed: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  };

  render() {
    const {
      onClick,
      props: { activeTab, label, indexed },
    } = this;

    let className = 'tab-list-item';

    if (activeTab === label) {
      // className += ' tab-list-active';
      className = 'tab-list-item-active';
    }

    return (
      <Draggable key={label} draggableId={label} index={parseInt(indexed)}>
        {(provided) => (
          <li
            className={className}
            onClick={onClick}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            {label}
          </li>
        )}
      </Draggable>
    );
  }
}

export default Tab;
